export const TOP_FILTER_URL = '/standard-search/topfilter';
export const SITE_SERVICE_URL = 'affordability/site-of-service-details';
export const Top_Filter_singleTin = 'extended-tins/top-filter?items=TIN';
export const PROGRAM_DETAILS = '/affordability/program-details';
export const HRL_DATE_FILTER_SOURCE = 'date-filter-source/HRL';
export const VBC_PROGRAM_DETAILS = '/vbc/program-details';
export const VBC_PAYOUTS = '/vbc/prior-year-payouts';
export const VBC_INFLATORS = '/vbc/inflators';
export const PNB_NDAR_DETAILS = 'pnb/ndar-details/';
export const PNB_CLM_DETAILS = 'pnb/clm-details/';
export const PNB_NPEM_DETAILS = 'pnb/pem-details/';
export const PNB_P360_DETAILS = 'pnb/p360-details/';
export const PNB_UHCI_DETAILS = 'pnb/uhci-details';
export const PNB_SAVE_EXIT_UPDATE_DOC = 'pnb/update-doc';
export const PNB_SAVE_EXIT_UPDATE_VERSION = 'pnb/update-version';
export const PNB_DELETE_DOC = 'pnb/delete-doc';
export const PNB_DELETE_VERSION = 'pnb/delete-version';
export const TOP_FILTER_EXTENDED_TIN = 'extended-tins/top-filter';
export const SMART_EDIT_FILTER_MULTITIN = 'extended-tins/top-filter?items=MULTITIN';
export const PNB_UPDATED_TIN = 'pnb/update-doc';
export const PNB_GET_DOCS_VERSION_BY_PBDID = 'pnb/get-docs-version-by-pbdid';
export const PNB_UPLOAD_TO_IMPACT = 'pnb/impact/upload-document';
